import { useCallback, memo } from 'react';
import { Linking } from 'react-native';
import { openChat } from '@betty/chat/state';
import { Box, Text, Button, Icon, BoxProps } from '@betty/moonlight';
import { useDispatch } from '@betty/toolkit/state';
import SocialLink from '../SocialLink/SocialLink';
import { SOCIAL_LINKS } from '../Footer/FooterLinks/FooterLinks.constants';

function ContactUsForm(props: BoxProps) {
  const dispatch = useDispatch();

  const onChatPress = useCallback(() => {
    dispatch(openChat());
  }, [dispatch]);

  const shareViaEmail = useCallback(() => {
    Linking.openURL(encodeURI('mailto:support@betty.ca'));
  }, []);

  return (
    <Box {...props}>
      <Text
        variant="h4"
        gradient="darkSurfaceAccent"
        locNS="account"
        locKey="titleContactUs"
        padding="space-600"
        marginLeft="-space-600"
      />
      <Box gap="space-500" flexDirection="column">
        <Text
          variant="body-m"
          color="darkSurfacePrimary"
          locNS="account"
          locKey="contactUs"
          paddingBottom="space-400"
        />
      </Box>
      <Button
        variant="secondary"
        locNS="common"
        locKey="liveChat"
        onPress={onChatPress}
        paddingBottom="space-200"
      />
      <Button
        variant="secondary"
        locNS="account"
        locKey="emailShare"
        onPress={shareViaEmail}
        alignSelf="center"
        width="100%"
        marginBottom="space-400"
      />
      <Box flexDirection="row" gap="space-200" alignItems="center">
        <Icon name="sparkle" />
        <Text
          variant="body-m-semi"
          locNS="account"
          locKey="followUsTitle"
          gradient="darkSurfaceAccent"
        />
      </Box>
      <Box>
        <Text
          variant="body-m"
          locNS="account"
          locKey="followUsDescription"
          color="darkSurfacePrimary"
          paddingBottom="space-400"
          marginTop="space-200"
        />
      </Box>
      <Box flexDirection="row">
        {SOCIAL_LINKS.map((link, index) => (
          <SocialLink {...link} key={index} />
        ))}
      </Box>
    </Box>
  );
}

export default memo(ContactUsForm);
